import React from "react";

const ProgressBar = ({ value = 0, label, small = false }) => {
  const v = Math.max(0, Math.min(100, Math.round(value || 0)));
  return (
    <div
      className={`cs-progress ${small ? "cs-progress-sm" : ""}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={v}
      aria-label={label || "Progress"}
    >
      <div className="cs-progress-fill" style={{ width: `${v}%` }} />
    </div>
  );
};

export default ProgressBar;
